export enum OMNI_MESSAGE_QUERY_TYPE {
  NEWER = 'ASC',
  OLDER = 'DESC'
}
